<script lang="ts">
    import { get } from 'svelte/store'
    import type DataProvider from '../services/data.provider'
    import { reservationFormValidation, reservationFieldStatuses } from '../form/reservation.form'
    import { createReservation } from '../api/reservation.api'
    import { t } from '../lib/i18n/t';

    export let dataProvider: DataProvider
    export let submitted: any

    let error = false
    let processing = false
    let fields = get(reservationFieldStatuses)
    reservationFieldStatuses.subscribe((data) => fields = data)

    async function onSubmit(): Promise<any> {
        if (reservationFormValidation(dataProvider)) {
            try {
                error = false
                processing = true
                await createReservation(dataProvider.reservationRequestData)
                // eslint-disable-next-line @typescript-eslint/no-unsafe-call
                submitted()
            } catch (e) {
                error = true
            } finally {
                processing = false
            }
        }
    }

</script>

<form on:submit|preventDefault={onSubmit} novalidate aria-label={t('form.elektronickeObjednani')}>
    <div class="bno-form-control" class:bno-form-control--error={fields.fullName.error}>
        {#if fields.fullName.error}
            <span class="bno-form-control__message">{fields.fullName.error}</span>
        {/if}
        <input id="name" bind:value={dataProvider.fullName} class="bno-form-control__input" type="text"
               aria-required="true" aria-disabled="false"/>
        <label class="bno-form-control__label " for="name">
            {t('form.jmenoAPrijmeni')}
        </label>
    </div>
    <div class="bno-form-control" class:bno-form-control--error={fields.email.error}>
        {#if fields.email.error}
            <span class="bno-form-control__message">{fields.email.error}</span>
        {/if}
        <input id="email" bind:value={dataProvider.email} class="bno-form-control__input" type="email"
               aria-required="true" aria-disabled="false"/>
        <label class="bno-form-control__label " for="email">
            {t('form.vaseEmailovaAdresa')}
        </label>
    </div>
    <div class="bno-form-control" class:bno-form-control--error={fields.phone.error}>
        {#if fields.phone.error}
            <span class="bno-form-control__message">{fields.phone.error}</span>
        {/if}
        <input id="phone" bind:value={dataProvider.phone} class="bno-form-control__input" type="tel"
               aria-required="true" aria-disabled="false"/>
        <label class="bno-form-control__label" for="phone">
            {t('form.telefon')}
        </label>
    </div>

    {#if dataProvider.isMmbRzSp}
        <div class="bno-form-control" class:bno-form-control--error={fields.mmb_rz_tp.error}>
            {#if fields.mmb_rz_tp.error}
                <span class="bno-form-control__message">{fields.mmb_rz_tp.error}</span>
            {:else}
                <!-- Note: help text -->
                <span class="bno-form-control__message">
                    {t('form.zadejteOznaceniVozidla')}
                </span>
            {/if}
            <input id="mmb_rz_tp" bind:value={dataProvider.mmb_rz_tp} class="bno-form-control__input" type="text"
                   aria-required="true" aria-disabled="false" style="max-width: 200px"/>
            <label class="bno-form-control__label" for="mmb_rz_tp">
                {t('form.rzVozidla')}
            </label>
        </div>
    {/if}

    <button type="submit" class="bno-button bno-button--primary" disabled={processing}>
        {t('form.dokoncitRezervaci')}
    </button>
    {#if error}
        {t('form.error.objednaniSeNepodariloDokoncit')}
    {/if}
</form>
